import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {Form, FormikProvider, useFormik} from 'formik';
import * as Yup from 'yup';
import * as actions from '../actions/TabDocumentsActions';
import {useOldInspectionDetailsContext} from './OldInspectionsDetailsContext';
import {useOldInspectionDocumentsContext} from './OldInspectionsDocumentsContext';

export function OldInspectionFormChangeNameProvider({fileID, currentFileName, onSubmit, children}) {
  const intl = useIntl();
  const {shumaID} = useOldInspectionDetailsContext();
  const {updateFileList} = useOldInspectionDocumentsContext();

  const invalidNameMessage = intl.formatMessage({
    id: 'tab-order-documents-form-invalidName',
    defaultMessage: 'this name already exists',
  });

  const getName = (fileName) => {
    const [originalName] = fileName.split('.');
    return originalName;
  };

  const getExtension = (fileName) => {
    const [/*originalName*/, extension] = fileName.split('.');
    return extension;
  };

  const formik = useFormik({
    initialValues: {fileName: getName(currentFileName)},
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      fileName: Yup.string().required('Name is required').test(
        'is-not-existed-name',
        invalidNameMessage,
        async (value) => {
          try {
            const extension = getExtension(currentFileName);
            const result = await actions.validateFileName(shumaID, [value, extension].join('.'));
            return result.isValid;
          } catch (e) {
            return false;
          }
        }
      ),
    }),
    onSubmit: async (values) => {
      try {
        const extension = getExtension(currentFileName);
        await actions.updateFileName(shumaID, fileID, [values.fileName, extension].join('.'));
        await updateFileList();
        if (onSubmit) {
          onSubmit();
        }
      } catch (e) {
        console.error(e);
      }
    }
  });

  return (
    <FormikProvider value={formik}>
      <Form>{children}</Form>
    </FormikProvider>
  );
}

OldInspectionFormChangeNameProvider.propTypes = {
  children: PropTypes.node,
  fileID: PropTypes.number.isRequired,
  currentFileName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
};